var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "page-container"
  }, [_c('div', {
    attrs: {
      "id": "searchArea"
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.dataForm
    },
    nativeOn: {
      "keyup": function keyup($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getDataList(1);
      }
    }
  }, [_c('div', {
    staticClass: "clearfix"
  }, [_c('div', {
    staticClass: "fl pb10"
  }, [_vm.isAuth('quotationV:save') ? _c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.addBtnLoading
    },
    on: {
      "click": function click($event) {
        return _vm.addOrUpdateHandle();
      }
    }
  }, [_vm._v("Add Quotation (V)")]) : _vm._e()], 1), _c('div', {
    staticClass: "fr"
  }, [_c('el-form-item', [_c('el-input', {
    staticClass: "wd500 input-with-select-lg",
    class: {
      hideInputActive: _vm.dataForm.noClientCode || _vm.dataForm.noLinkedEngagement
    },
    attrs: {
      "placeholder": _vm.kwPlaceHolder
    },
    model: {
      value: _vm.dataForm.keyword,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "keyword", $$v);
      },
      expression: "dataForm.keyword"
    }
  }, [_c('el-select', {
    attrs: {
      "slot": "prepend",
      "placeholder": "please select"
    },
    on: {
      "change": _vm.kwTypeChange
    },
    slot: "prepend",
    model: {
      value: _vm.dataForm.kwType,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "kwType", $$v);
      },
      expression: "dataForm.kwType"
    }
  }, _vm._l(_vm.kwTypes, function (item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.title,
        "value": item.value
      }
    });
  }), 1)], 1)], 1), _c('el-form-item', [_c('business-info-select-remote-search', {
    attrs: {
      "placeholder": "Transaction No."
    },
    model: {
      value: _vm.dataForm.applymentNo,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "applymentNo", $$v);
      },
      expression: "dataForm.applymentNo"
    }
  })], 1), _c('el-form-item', [_c('el-select', {
    staticClass: "wd160",
    attrs: {
      "multiple": "",
      "clearable": "",
      "placeholder": "Status"
    },
    model: {
      value: _vm.dataForm.status,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "status", $$v);
      },
      expression: "dataForm.status"
    }
  }, _vm._l(_vm.adjustmentStatusList, function (item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.title,
        "value": item.value
      }
    });
  }), 1)], 1), _c('el-form-item', [_c('el-select', {
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "Supplier"
    },
    model: {
      value: _vm.dataForm.supplierId,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "supplierId", $$v);
      },
      expression: "dataForm.supplierId"
    }
  }, _vm._l(_vm.supplierList, function (item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.companyName,
        "value": item.id
      }
    });
  }), 1)], 1), _c('el-form-item', [_c('el-button', {
    directives: [{
      name: "debounce",
      rawName: "v-debounce"
    }],
    attrs: {
      "icon": "el-icon-search",
      "type": "primary",
      "plain": ""
    },
    on: {
      "click": function click($event) {
        return _vm.getDataList(1);
      }
    }
  }, [_vm._v("Search")])], 1)], 1)])])], 1), _c('div', [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.dataListLoading,
      expression: "dataListLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "max-height": "680",
      "data": _vm.dataList,
      "default-sort": {
        prop: 'createTime',
        order: 'descending'
      }
    },
    on: {
      "sort-change": _vm.tableSortChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "expand",
      "width": "30px",
      "fixed": "left"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(props) {
        return [_c('Expand', {
          attrs: {
            "itemList": props.row.itemList || [],
            "bankAccountIds": props.row.bankAccountIds || [],
            "supplierBankAccountList": _vm.supplierBankAccountList
          }
        })];
      }
    }])
  }), _c('el-table-column', {
    attrs: {
      "prop": "adjustmentNo",
      "align": "center",
      "label": "Quotation (V)",
      "sortable": "custom",
      "width": "150",
      "fixed": "left"
    }
  }), _c('el-table-column', {
    attrs: {
      "prop": "applymentNo",
      "align": "center",
      "label": "Trans No.",
      "width": "100",
      "fixed": "left"
    }
  }), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "Supplier",
      "width": "150",
      "fixed": "left"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        var _scope$row$supplier;

        return [_c('p', [_vm._v(_vm._s(((_scope$row$supplier = scope.row.supplier) === null || _scope$row$supplier === void 0 ? void 0 : _scope$row$supplier.abbr) || ""))])];
      }
    }])
  }), _c('el-table-column', {
    attrs: {
      "prop": "clientCode",
      "align": "center",
      "label": "Client Code",
      "width": "110"
    }
  }), _c('el-table-column', {
    attrs: {
      "prop": "billingParty",
      "align": "center",
      "label": "Billing Party",
      "min-width": "200"
    }
  }), _c('el-table-column', {
    attrs: {
      "prop": "address",
      "align": "center",
      "label": "Address",
      "min-width": "250"
    }
  }), _c('el-table-column', {
    attrs: {
      "prop": "country",
      "align": "center",
      "label": "Country",
      "min-width": "120"
    }
  }), _c('el-table-column', {
    attrs: {
      "prop": "postalCode",
      "align": "center",
      "label": "Postal Code",
      "min-width": "110"
    }
  }), _c('el-table-column', {
    attrs: {
      "prop": "applyReason",
      "align": "center",
      "label": "Description / Apply Reason",
      "min-width": "250"
    }
  }), _c('el-table-column', {
    attrs: {
      "prop": "attachmentUrls",
      "align": "center",
      "label": "Attachments",
      "min-width": "130"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return _vm._l(scope.row.attachmentUrls, function (item) {
          return _c('p', {
            key: item.url
          }, [_c('a', {
            attrs: {
              "href": item.url,
              "target": "_target"
            }
          }, [_vm._v(_vm._s(item.name))])]);
        });
      }
    }])
  }), _c('el-table-column', {
    attrs: {
      "prop": "createTime",
      "align": "center",
      "label": "Create Time",
      "sortable": "custom",
      "min-width": "130"
    }
  }), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "align": "center",
      "label": "Status",
      "min-width": "144"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c('div', {
          staticClass: "fxRow"
        }, [_c('p', {
          staticClass: "mr4"
        }, [_vm._v(_vm._s(_vm.adjustmentStatusFormat(scope.row.status)))]), _c('el-link', {
          attrs: {
            "type": "primary",
            "underline": false
          },
          on: {
            "click": function click($event) {
              return _vm.openStatusHistoryModal(scope.row);
            }
          }
        }, [_vm._v("(Track)")])], 1)];
      }
    }])
  }), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "Linked Engagement ID",
      "width": "184"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        var _scope$row$engagement;

        return [((_scope$row$engagement = scope.row.engagementList) === null || _scope$row$engagement === void 0 ? void 0 : _scope$row$engagement.length) > 0 ? _c('span', [_vm._v(_vm._s(_vm.engagementIdDeduplicateFormat(scope.row.engagementList)))]) : _vm._e()];
      }
    }])
  }), _c('el-table-column', {
    attrs: {
      "prop": "transactionType",
      "align": "center",
      "label": "Transaction Type",
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c('p', [_vm._v(_vm._s(_vm.transactionTypeFormat(scope.row.transactionType)))])];
      }
    }])
  }), _c('el-table-column', {
    attrs: {
      "align": "center",
      "width": "120",
      "label": "Order Status"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        var _scope$row, _scope$row$customerOr;

        return [_c('p', [_vm._v(_vm._s(_vm.orderStatusFormat((_scope$row = scope.row) === null || _scope$row === void 0 ? void 0 : (_scope$row$customerOr = _scope$row.customerOrder) === null || _scope$row$customerOr === void 0 ? void 0 : _scope$row$customerOr.status)))])];
      }
    }])
  }), _c('el-table-column', {
    attrs: {
      "align": "center",
      "width": "100",
      "label": "Action",
      "fixed": "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_vm.isAuth('quotationV:update') && (scope.row.status == 'PENDING' || scope.row.status == 'REJECTED') ? _c('el-button', {
          staticClass: "fwb",
          attrs: {
            "type": "text"
          },
          on: {
            "click": function click($event) {
              return _vm.addOrUpdateHandle(scope.row);
            }
          }
        }, [_vm._v(" Edit ")]) : _vm._e(), _vm.isAuth('quotationV:audit') && scope.row.status == 'PENDING' ? _c('el-button', {
          staticClass: "fwb",
          attrs: {
            "type": "text"
          },
          on: {
            "click": function click($event) {
              return _vm.reviewHandle(scope.row);
            }
          }
        }, [_vm._v(" Review ")]) : _vm._e(), _vm.isAuth('quotationV:delete') && (scope.row.status == 'PENDING' || scope.row.status == 'REJECTED') ? _c('el-button', {
          staticClass: "fwb",
          attrs: {
            "type": "text"
          },
          on: {
            "click": function click($event) {
              return _vm.deleteHandle(scope.row);
            }
          }
        }, [_vm._v(" Delete ")]) : _vm._e(), _vm.isAuth('quotationV:forfeit') && scope.row.status == 'PASSED' && scope.row.customerOrder && (scope.row.customerOrder.status == 'UNPAID' || scope.row.customerOrder.status == 'PARTLY_PAID') ? _c('el-button', {
          staticClass: "fwb",
          attrs: {
            "type": "text"
          },
          on: {
            "click": function click($event) {
              return _vm.statusUpdateHandle(scope.row, 'Forfeit');
            }
          }
        }, [_vm._v(" Forfeit ")]) : _vm._e(), _vm.isAuth('quotationV:reActive') && scope.row.status == 'FORFEITED' && scope.row.customerOrder && (scope.row.customerOrder.status == 'UNPAID' || scope.row.customerOrder.status == 'PARTLY_PAID' || scope.row.customerOrder.status == 'FORFEITED') ? _c('el-button', {
          staticClass: "fwb",
          attrs: {
            "type": "text"
          },
          on: {
            "click": function click($event) {
              return _vm.statusUpdateHandle(scope.row, 'Re-active');
            }
          }
        }, [_vm._v(" Re-active ")]) : _vm._e()];
      }
    }])
  })], 1)], 1), _c('pagination', {
    attrs: {
      "current": _vm.current,
      "pageSize": _vm.pageSize,
      "totalCount": _vm.totalCount
    },
    on: {
      "size-change": _vm.sizeChangeHandle,
      "current-change": _vm.currentChangeHandle
    }
  }), _c('add-or-update', {
    ref: "addOrUpdate",
    attrs: {
      "supplierList": _vm.supplierList,
      "invoiceTemplateList": _vm.invoiceTemplateList
    },
    on: {
      "refreshDataList": _vm.getDataList
    }
  }), _c('status-history', {
    ref: "statusHistoryModal"
  }), _c('supplement-review', {
    ref: "supplementReviewModal",
    on: {
      "refreshStatus": _vm.getDataList
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }